// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"374":"f924c6dd9dfd53e7","378":"a410340c867eb61e","453":"d9e3d5161cdd172d","658":"5cf79a8b7130d644"}[chunkId] + ".js";
};